/**
 * @name Funds Config
 * @memberof module:common/config
 * @type {Config}
 * @return {Object} Configurations of API
 */

import API from '../config';

const base = `${API.BASE_DEV_HOST}/api/funds`;

export const byId = `${base}`;
export const updateById = `${base}`;
export const newFund = `${base}`;
export const fundById = (fundId: number) => `${base}/${fundId}`;
export const getMeasurementDateByFundId = (fundId: string) => `${base}/measurement-dates/funds/${fundId}`;
export const createCompanyForMeasurementDate = (mpId: string) => `${base}/measurement-dates/${mpId}/company`;
export const addCompanyToMeasurementDate = `${API.BASE_DEV_HOST}/fund-companies`;
export const getFundSummary = (fundId: string, date?: string | null) => date ? `${base}/${fundId}/summary?date=${date}` : `${base}/${fundId}/summary`;
export const getFundInvestments = (fundId: string, date: string | null | undefined, checkForExport: boolean) => {
  const baseUrl = `${base}/${fundId}/investments`;
  const params = new URLSearchParams();
  if (date) {
    params.append('date', date);
  }
  params.append('export', checkForExport.toString());
  return `${baseUrl}?${params.toString()}`;
};
export const getFundAllocations = (fundId: string, date?: string | null) => date ? `${base}/${fundId}/allocations?date=${date}` : `${base}/${fundId}/allocations`;
export const getCompaniesByFundId = (fundId: number) => `${base}/${fundId}/companies/`;
